// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__332da","subheader":"ReorderModal_subheader__1HaSD","listWrap":"ReorderModal_listWrap__3Y78m"};